import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { formatCurrency } from '../../../helpers'
import * as E from './releaseSectionElements'
import { ITheme } from 'utils/type'

interface IInputDataProps {
  isRelease: boolean
  isExistingCar: boolean
  userFirstName: string
  oldOutOfPocketPerPay: number
  outOfPocketPerPay: number
  theme: ITheme
}

interface IReleaseCardItemDataProps {
  heading: string
  text: string
  amount: number
}

const ReleaseSection = ({
  isRelease,
  isExistingCar,
  userFirstName,
  oldOutOfPocketPerPay,
  outOfPocketPerPay,
  theme,
}: IInputDataProps) => {
  let difference: number = Math.abs(oldOutOfPocketPerPay - outOfPocketPerPay)

  const ReleaseCardItem = ({
    heading,
    text,
    amount,
  }: IReleaseCardItemDataProps) => {
    return (
      <div>
        <E.releaseCardHeading theme={theme}>{heading}</E.releaseCardHeading>
        <E.releaseCardDetailLine>
          <E.releaseCardDetailTextSpan>{text}</E.releaseCardDetailTextSpan>
          <span>{formatCurrency(amount)}</span>
        </E.releaseCardDetailLine>
      </div>
    )
  }

  const ValuesDiv = () => {
    return (
      <E.releaseCard theme={theme}>
        <Row>
          <E.releaseCardLeftBorder
            theme={theme}
            isExistingCar={isExistingCar}
          />
          <E.releaseCardContent theme={theme} isExistingCar={isExistingCar}>
            <ReleaseCardItem
              heading={isExistingCar ? 'Existing lease' : 'Existing car'}
              text="How much comes out of your take home pay:"
              amount={oldOutOfPocketPerPay}
            />
            <ReleaseCardItem
              heading={isExistingCar ? 'New lease' : 'New car'}
              text="How much comes out of your take home pay:"
              amount={outOfPocketPerPay}
            />
            <ReleaseCardItem
              heading="Difference per pay"
              text="The difference between your current lease and this one:"
              amount={difference}
            />
          </E.releaseCardContent>
        </Row>
      </E.releaseCard>
    )
  }

  return (
    <E.releaseSection theme={theme}>
      <Container className="section pt-3 pb-3 text-center">
        <E.releaseHeader theme={theme}>
          {"Here's how " +
            (isExistingCar ? 'this new lease' : 'your upgrade ') +
            ' compares with your current lease'}
        </E.releaseHeader>
        <E.releaseSubText theme={theme}>
          {userFirstName +
            ', knowing the lease on your current vehicle is due to end soon - your decision on what to do next is an important one. Take a look below at how an estimate on this lease compares with your current one -'}
        </E.releaseSubText>
        <ValuesDiv />
        <E.releaseSubText theme={theme} className="mt-3">
          {'As you can see ' +
            userFirstName +
            ', for as estimated ' +
            formatCurrency(difference) +
            (oldOutOfPocketPerPay < outOfPocketPerPay ? ' more' : ' less') +
            ', you can ' +
            (isExistingCar
              ? 'keep your current car!'
              : 'potentially acquire a new car!')}
        </E.releaseSubText>
      </Container>
    </E.releaseSection>
  )
}

export default ReleaseSection
